import { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../Header/Header";
import Menu from "../Menu/Menu";
import { Container, Col } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Layout.css";

import { getSindicatoById } from "../../services/sindicatoService";
import { getExtratoSolicitacaoById } from "../../services/ExtractService";

const SIDEBAR_STORAGE_KEY = "merit_sidebar_collapsed_v1";
const SINDICATO_HEADER_KEY = "sindicatoHeader";

const Layout = ({ children, resolveSindicatoPorResposta = false }) => {
  const { idResposta, idSindicato } = useParams();

  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, collapsed ? "1" : "0");
    } catch {}
  }, [collapsed]);

  useEffect(() => {
    let mounted = true;

    const carregarSindicatoHeader = async () => {
      if (!idResposta && !idSindicato) {
        try {
          localStorage.removeItem(SINDICATO_HEADER_KEY);
        } catch {}
        window.dispatchEvent(new Event("sindicatoHeaderUpdated"));
        return;
      }

      try {
        let sigla = "";
        let cnpj = "";
        let nome = "";
        let id = idSindicato ? Number(idSindicato) : undefined;


        if (resolveSindicatoPorResposta && idResposta) {
          try {
            const detalhe = await getExtratoSolicitacaoById(idResposta);
            sigla = detalhe?.dadosSindicato?.sigla || "";
            cnpj = detalhe?.dadosSindicato?.cnpj || "";
            nome = detalhe?.dadosSindicato?.nome || "";
          } catch {}
        } else if (idSindicato) {
          try {
            const resp = await getSindicatoById(idSindicato);
            const data = resp?.data;
            sigla = data?.sigla || "";
            cnpj = data?.cnpj || "";
            nome = data?.nome || "";
            id = data?.id ?? id;
          } catch {}
        }

        if (!mounted) return;

        if (!sigla || !cnpj) {
          throw new Error("Sindicato não encontrado");
        }

        try {
          localStorage.setItem(
            SINDICATO_HEADER_KEY,
            JSON.stringify({ id, sigla, cnpj, nome }),
          );
        } catch {}

        window.dispatchEvent(new Event("sindicatoHeaderUpdated"));
      } catch (e) {
        console.error("[Layout] Erro ao buscar sindicato:", e);

        if (!mounted) return;

        try {
          localStorage.removeItem(SINDICATO_HEADER_KEY);
        } catch {}

        window.dispatchEvent(new Event("sindicatoHeaderUpdated"));
      }
    };

    carregarSindicatoHeader();

    return () => {
      mounted = false;
    };
  }, [idResposta, idSindicato, resolveSindicatoPorResposta]);

  const toggleSidebar = () => setCollapsed((prev) => !prev);

  return (
    <div className="layout-container">
      <Header />

      <Container fluid className="main-container">
        <Col xs="auto" className={`sidebar ${collapsed ? "collapsed" : ""}`}>
          <button
            type="button"
            className="sidebar-toggle"
            onClick={toggleSidebar}
            aria-label={collapsed ? "Expandir menu" : "Recolher menu"}
            title={collapsed ? "Expandir" : "Recolher"}
          >
            {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
          </button>

          <Menu
            collapsed={collapsed}
            onExpandSidebar={() => setCollapsed(false)}
          />
        </Col>

        <Col className="content-area">{children}</Col>
      </Container>
    </div>
  );
};

export default memo(Layout);
